// export constants that we use in the rest of the program to avoid working with strings.
export const setAdsQueryProviders = "setAdsQueryProviders"
export const setAdsQuery = "setAdsQuery"
export const setAdsRoFQuery = "setAdsRoFQuery"
export const setAdsResults = "setAdsResults"
export const setAdsRoFResults = "setAdsRoFResults"
export const setAdsRoFResultsTableData = "setAdsRoFResultsTableData"
export const setAdsCampaignReportQuery = "setAdsCampaignReportQuery"
export const setAdsCampaignReportResults = "setAdsCampaignReportResults"
export const setAdsCampaignReportMeasureSumMode = "setAdsCampaignReportMeasureSumMode"
export const setAdsCampaignReportCurrentTargetGroup = "setAdsCampaignReportCurrentTargetGroup"
export const setAdsCampaignReportMeasureTypeSelected = "setAdsCampaignReportMeasureTypeSelected"
export const setAdsUniverseSize = "setAdsUniverseSize"
export const setAdsPanelSize = "setAdsPanelSize"
export const setAdsColumnTypes = "setAdsColumnTypes"
export const setAdsInitStatus = "setAdsInitStatus"
export const setAdsQueryForAPI = "setAdsQueryForAPI"
export const setAdsChannels = "setAdsChannels"
export const setAdsStartdate = "setAdsStartdate"
export const setAdsEnddate = "setAdsEnddate"
export const setAdsDefaultColumns = "setAdsDefaultColumns"
export const setAdsAllWithStarSelected = "setAdsAllWithStarSelected"
export const setAdsProviders = "setAdsProviders"
export const setAdsHaveSelectedRow = "setAdsHaveSelectedRow"
export const setAdsExportQuery = "setAdsExportQuery"
export const setAdsFormFields = "setAdsFormFields"
export const setQueryCostData = "setAdsQueryCostData"
export const setQueryCostLoading = "setAdsQueryCostLoading"
export const setQueryCostError = "setAdsQueryCostError"
export const setAdsQueryBeforeChange = "setAdsQueryBeforeChange"
export const setAdsStringForFilterBeforeChange = "setAdsStringForFilterBeforeChange"
export const setAdsHasExcludedRow = "setAdsHasExcludedRow"
export const setAdsSumVisible = "setAdsSumVisible"
export const setAdsQueryDefault = "setAdsQueryDefault"
export const setAdsHasSetDefaultQuery = "setAdsHasSetDefaultQuery"

